$('.menu__item a')
  .on('mouseenter', function() {
    const $this = $(this);
    const isFirstLevelLink = $this.is('.nav > ul > li > a');

    const item_title = $this.attr('data-title');
    const item_subtitle = $this.attr('data-subtitle');
    const item_content = $this.attr('data-content');
    let item_image_url = $this.attr('data-banner') || '';

    let $title_container = $this.closest('.dropdown--grid').find('.dropdown__title');
    let $subtitle_container = $this.closest('.dropdown--grid').find('.dropdown__subtitle');
    let $description_container = $this.closest('.dropdown--grid').find('.dropdown_description');
    let $image_container = $this.closest('.dropdown--grid').find('.dropdown__image');

    if (isFirstLevelLink) {
      $title_container = $this.siblings('.dropdown--grid').find('.dropdown__title');
      $subtitle_container = $this.siblings('.dropdown--grid').find('.dropdown__subtitle');
      $description_container = $this.siblings('.dropdown--grid').find('.dropdown_description');
      $image_container = $this.siblings('.dropdown--grid').find('.dropdown__image');
    }

    if (item_image_url.indexOf('no-image') != -1 || item_image_url == '') {
      item_image_url = $image_container.data('default-image-url');
    }

    $title_container.text(item_title);
    $subtitle_container.text(item_subtitle);
    $description_container.text(item_content);
    $image_container.attr('style', `background-image: url('${item_image_url}');`);
  })
  .on('mouseleave', function() {
    const $this = $(this);
    const $title_container = $this.closest('.dropdown--grid').find('.dropdown__title');
    const $subtitle_container = $this.closest('.dropdown--grid').find('.dropdown__subtitle');
    const $description_container = $this.closest('.dropdown--grid').find('.dropdown_description');
    const $image_container = $this.closest('.dropdown--grid').find('.dropdown__image');
    const $parentLink = $this.closest('.dropdown--grid').prev();
    const parentLinkTitle = $parentLink.data('title');
    const parentLinkSubtitle = $parentLink.data('subtitle');
    const parentLinkContent = $parentLink.data('content');

    let title_container_text = '';
    let subtitle_container_text = '';
    let description_container_text = '';
    let image_url = '';

    if ($parentLink) {
      title_container_text = parentLinkTitle;
      subtitle_container_text = parentLinkSubtitle;
      description_container_text = parentLinkContent;
      image_url = $image_container.data('default-image-url');
    }

    $title_container.text(title_container_text);
    $subtitle_container.text(subtitle_container_text);
    $description_container.text(description_container_text);
    $image_container.attr('style', `background-image: url('${image_url}');`);
  });

$('.nav > ul > li > a').on('mouseenter', function() {
  $(this)
    .closest('li')
    .addClass('hover');
});

$('.nav > ul > li').on('mouseleave', function() {
  $(this).removeClass('hover');
});

let guidesParent = $('.guide-dropdown-parent');
let guidesParentLength = guidesParent.length;

for (let i = 0; i < guidesParentLength ; i++) {
  let guides_title = $(guidesParent[i]).children().attr('data-title');
  let guides_content = $(guidesParent[i]).children().attr('data-content');

  $(guidesParent[i]).find('.dropdown-guides__wrap').first().find('.dropdown__title').text(guides_title);
  $(guidesParent[i]).find('.dropdown-guides__wrap').first().find('.dropdown__description').text(guides_content);
  $(guidesParent[i]).find('.dropdown-guides__wrap').first().addClass('active');

  let guidesLink = $(guidesParent[i]).find('.menu__dropdown .menu__item a');
  let guidesLinkLength = guidesLink.length;
  let guidesContent = $(guidesParent[i]).find('.dropdown-guides__wrap');

  for (let i = 0; i < guidesLinkLength; i++) {
    $(guidesLink[i]).parent().hover(function(){
      $(guidesContent).removeClass('active');
      let guides_title = $(this).find('a').attr('data-title');
      let guides_content = $(this).find('a').attr('data-content');
      $(this).closest('.guide-dropdown').find('.dropdown__title').text(guides_title);
      $(this).closest('.guide-dropdown').find('.dropdown__description').text(guides_content);
      $(guidesContent[i]).addClass('active');
    }, function(){
      let guides_title = $(this).closest('.guide-dropdown-parent').children().attr('data-title');
      let guides_content = $(this).closest('.guide-dropdown-parent').children().attr('data-content');
      $(this).closest('.guide-dropdown').find('.dropdown__title').text(guides_title);
      $(this).closest('.guide-dropdown').find('.dropdown__description').text(guides_content);
    });
  }
}
